import React from "react";
import { useNavigate } from "react-router-dom";
import { FiExternalLink, FiMapPin, FiPackage, FiPieChart, FiUsers } from "react-icons/fi";
import brandLogo from "../../assets/logo.png";

const AdminNavbar = () => {
  const navigate = useNavigate();

  return (
    <div className="roha-admin-navbar">
      <div className="roha-admin-navbar__brand">
        <img src={brandLogo} alt="Roha Jewellery logo" className="roha-admin-navbar__logo" />
        <div>
          <p className="roha-admin-navbar__eyebrow">Roha admin</p>
          <h1>Luxury commerce control center</h1>
          <p className="roha-admin-navbar__meta"><FiMapPin /> Addis Ababa brand studio and ecommerce operations</p>
        </div>
      </div>
      <div className="roha-admin-navbar__actions">
        <button type="button" className="roha-admin-navbar__chip" onClick={() => navigate("/admin/dashboard")}>
          <FiPieChart /> Overview
        </button>
        <button type="button" className="roha-admin-navbar__chip" onClick={() => navigate("/admin/products")}>
          <FiPackage /> Catalogue
        </button>
        <button type="button" className="roha-admin-navbar__chip" onClick={() => navigate("/admin/users")}>
          <FiUsers /> Users
        </button>
        <button type="button" className="roha-admin-navbar__chip" onClick={() => navigate("/")}>
          <FiExternalLink /> Visit store
        </button>
      </div>
    </div>
  );
};

export default AdminNavbar;
